import './ValueIndicator.scss';

import React from 'react';

import { ReactComponent as ArrowDown } from 'assets/icons/market-down.svg';
import { ReactComponent as ArrowUp } from 'assets/icons/market-up.svg';
import Optioner from 'components/shared/Optioner/Optioner';
import { isNegativeValue, isPositiveValue } from 'services/Calculation';

const ValueIndicator = ({ value }) => {
  return (
    <Optioner
      val={{
        positive: isPositiveValue(value),
        negative: isNegativeValue(value)
      }}>
      {{
        positive: <ArrowUp className="value-arrow-up" />,
        negative: <ArrowDown className="value-arrow-down" />,
        _: <div className="no-value" />
      }}
    </Optioner>
  );
};

export default ValueIndicator;
